import { render, staticRenderFns } from "./SingleSignOnGoogle.vue?vue&type=template&id=54f4db71&scoped=true"
import script from "./SingleSignOnGoogle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSignOnGoogle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SingleSignOnGoogle.vue?vue&type=style&index=0&id=54f4db71&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f4db71",
  null
  
)

export default component.exports